/* Argaman: FAQ page accordion from the page's own h2 + paragraphs (content stays editable in Shopify admin). */
(function () {
  var rte = document.querySelector('[data-ag-faq] .rte');
  if (!rte || rte.getAttribute('data-ag-done')) return;
  var heads = rte.querySelectorAll('h2, h3');
  if (!heads.length) return;
  rte.setAttribute('data-ag-done', '1');
  Array.prototype.forEach.call(heads, function (h, i) {
    var d = document.createElement('details'); d.className = 'ag-faq'; if (i === 0) d.open = true;
    var s = document.createElement('summary'); s.textContent = h.textContent; d.appendChild(s);
    var body = document.createElement('div'); body.className = 'ag-faq__body';
    var n = h.nextElementSibling;
    while (n && !/^H[23]$/.test(n.tagName)) { var next = n.nextElementSibling; body.appendChild(n); n = next; }
    d.appendChild(body); h.parentNode.replaceChild(d, h);
  });
})();
